class CarouselIndicators extends HTMLElement {
  constructor() {
    super();
    this.slider = document.querySelector(this.dataset.targetEl);

    if (!this.slider) {
      return;
    }

    this.slides = this.slider.querySelectorAll('ul > li');

    this.observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.5,
    };

    this.observer = new IntersectionObserver(this.handleIntersection.bind(this), this.observerOptions);

    // Loop through slides and add an intersection observer to each slide
    this.slides.forEach((slide, index) => {
      this.observer.observe(slide);

      slide.dataset.slideIndex = index;
    });
  }

  handleIntersection(entries) {
    entries.forEach((entry, index) => {
      const slide = entry.target;
      const slideIndex = slide.dataset.slideIndex;

      if (entry.isIntersecting) {
        this.activateSlide(slideIndex);
      }
    });
  }

  activateSlide(slideIndex) {
    const activeSlide = this.querySelector('ul > li.active');
    if (activeSlide) {
      activeSlide.classList.remove('active');
    }

    const targetSlide = this.querySelectorAll(`ul > li`)[slideIndex];
    if (targetSlide) {
      targetSlide.classList.add('active');
    }
  }

  connectedCallback() {
    // Connect the carousel indicators
    const buttons = this.querySelectorAll('button');
    buttons.forEach((button) => {
      button.addEventListener('click', (event) => {
        const targetIndex = [...button.parentElement.parentElement.children].indexOf(button.parentElement);
        this.slides[targetIndex].scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
      });
    });
  }
}

customElements.define('carousel-indicators', CarouselIndicators);
